import { HeycarImage } from '@core/Components/HeycarImage/HeycarImage';
import { heycarLoader } from '@core/Components/HeycarImage/HeycarLoader';
import { IMAGE_SIZES, SRC_SET_WIDTHS } from '@core/Constants/ImageCarousel.constants';
import type { Tenant } from '@core/Entities/App/Tenants.entity';
import type { VehicleImage } from '@core/Entities/Vehicle/VehicleImage.entity';
import { getImgLoader } from '@core/Utils/Image/GetImgLoader';
import { purchaseProNativeRatioLoader } from '@shared-components/PpImage/Utils/PurchaseProLoader';

type Props = {
  className: string;
  image: VehicleImage;
  isCurrent: boolean;
  tenant?: Tenant;
};

export const PatchworkGalleryImage = ({ className, image, isCurrent, tenant }: Props) => {
  const size = tenant === 'purchasePro' ? 'pdpPurchaseProPatchwork' : 'small';
  const defaultLoader = tenant === 'purchasePro' ? purchaseProNativeRatioLoader : heycarLoader;

  return (
    <HeycarImage
      src={image.url}
      className={className}
      alt={image.altText || ''}
      loader={getImgLoader(image, defaultLoader)}
      sizes={IMAGE_SIZES[size]}
      srcSetWidths={SRC_SET_WIDTHS[size]}
      forceVisible={isCurrent}
      preload={isCurrent}
      isStandAlone
    />
  );
};
